interface TaskCompletionWidgetProps {
  tasksCompletedToday: number;
  totalTasksToday: number;
  tasksCompletedThisWeek: number;
  totalTasksThisWeek: number;
}

export function TaskCompletionWidget({
  tasksCompletedToday,
  totalTasksToday,
  tasksCompletedThisWeek,
  totalTasksThisWeek,
}: TaskCompletionWidgetProps) {
  const todayPercentage = totalTasksToday > 0 ? Math.round((tasksCompletedToday / totalTasksToday) * 100) : 0;
  const weekPercentage = totalTasksThisWeek > 0 ? Math.round((tasksCompletedThisWeek / totalTasksThisWeek) * 100) : 0;

  return (
    <div className="bg-white rounded-md shadow-[0px_2px_15px_-3px_rgba(0,0,0,0.07),0px_10px_20px_-2px_rgba(0,0,0,0.04)] p-6 h-[220px] flex flex-col">
      <p className="text-[12px] text-[#808080] mb-6 uppercase tracking-wide">Task Completion</p>

      <div className="space-y-6 flex-1">
        {/* Today's Tasks */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] text-[#262626] font-medium">Today</span>
            <span className="text-[11px] text-[#808080]">
              {tasksCompletedToday} of {totalTasksToday} tasks
            </span>
          </div>
          
          {/* Progress Bar */}
          <div className="relative h-2 bg-[#e7e7e7] rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-[#e30840] rounded-full transition-all duration-500"
              style={{ width: `${todayPercentage}%` }}
            />
          </div>
          
          {/* Percentage */}
          <div className="flex items-center justify-between mt-2">
            <span className="text-[10px] text-[#808080]">
              {todayPercentage}% complete
            </span>
            {totalTasksToday - tasksCompletedToday > 0 && (
              <span className="text-[10px] text-[#e30840] font-medium">
                {totalTasksToday - tasksCompletedToday} remaining
              </span>
            )}
          </div>
        </div>

        {/* This Week's Tasks */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-[11px] text-[#262626] font-medium">This Week</span>
            <span className="text-[11px] text-[#808080]">
              {tasksCompletedThisWeek} of {totalTasksThisWeek} tasks
            </span>
          </div>
          
          {/* Progress Bar */}
          <div className="relative h-2 bg-[#e7e7e7] rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-[#e30840] rounded-full transition-all duration-500"
              style={{ width: `${weekPercentage}%` }}
            />
          </div>
          
          {/* Percentage */}
          <div className="flex items-center justify-between mt-2">
            <span className="text-[10px] text-[#808080]">
              {weekPercentage}% complete
            </span>
            {totalTasksThisWeek - tasksCompletedThisWeek > 0 && (
              <span className="text-[10px] text-[#e30840] font-medium">
                {totalTasksThisWeek - tasksCompletedThisWeek} remaining
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
